import { createSlice } from "@reduxjs/toolkit";
import { doGetUser, doUpdateUser, doRemoveUser } from "./user.service";

const initialState = {
  fullName: null,
  email: null,
  firstTime: null,
  statusText: null,
  planExpiry: null,
  planUid: null,
  customerId: null,
  planCancel: null,
  isTelegramJoined: false,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    clearUserData(state) {
      state.fullName = null;
      state.email = null;
      state.firstTime = null;
      state.statusText = null;
      state.planExpiry = null;
      state.planUid = null;
      state.customerId = null;
      state.planCancel = null;
    },
  },
  extraReducers: (builder) => {
    // Handling get user action
    builder.addCase(doGetUser.pending, (state, action) => {
      state.statusText = "Getting user data";
    });
    builder.addCase(doGetUser.fulfilled, (state, action) => {
      state.fullName = action.payload.fullName;
      state.firstTime = action.payload.firstTime;
      state.planExpiry = action.payload.planExpiry;
      state.planUid = action.payload.planUid;
      state.customerId = action.payload.customerId;
      state.planCancel = action.payload.planCancel;
      state.isTelegramJoined = action.payload.isTelegramJoined;
      state.statusText = "Fetched user data successfully";
    });
    builder.addCase(doGetUser.rejected, (state, action) => {
      state.statusText = "Error getting user data";
    });

    // Handling user update action
    builder.addCase(doUpdateUser.pending, (state, action) => {
      state.statusText = "Updating user data";
    });
    builder.addCase(doUpdateUser.fulfilled, (state, action) => {
      state.fullName = action.payload.fullName;
      state.isTelegramJoined = action.payload.isTelegramJoined;
      state.statusText = "User data updated successfully";
    });
    builder.addCase(doUpdateUser.rejected, (state, action) => {
      state.statusText = "Error updating user data";
    });

    // Handling user remove action
    builder.addCase(doRemoveUser.pending, (state, action) => {
      state.statusText = "Logging out user";
    });
    builder.addCase(doRemoveUser.fulfilled, (state, action) => {
      state.firstTime = null;
      state.fullName = null;
      state.email = null;
      state.statusText = "Successfully logged out";
    });
    builder.addCase(doRemoveUser.rejected, (state, action) => {
      state.statusText = "Error logging out";
    });
  },
});

export const { clearUserData } = userSlice.actions;
export default userSlice.reducer;
